import { useLocation } from 'react-router-dom';
import { NotFoundState } from '../../ds';

/**
 * The real Not found (Shell-NotFound) inside the shell: unknown routes render it in place (the address stays in the bar
 * and is shown as "Requested …"); `/notfound` (old redirects) shows it without the address.
 */
export function NotFoundPage() {
    const { pathname, search } = useLocation();
    const requested = pathname === '/notfound' ? undefined : `${pathname}${search}`;
    return <NotFoundState requested={requested} />;
}
